module.exports = __webpack_public_path__ + "static/decrease-turnover-d980348698be8b82465af9ee154dcbf9.svg";